import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { prismicImage } from "src/common/utils/prismic-image";
import RichText from "../Prismic/RichText";
import Button from "wonderbly-components/lib/Button";
import SectionHeading from "src/client/js/view/components/SectionHeading";

import "./Features.scss";

const FeatureLink = (props) => {
  if (props.href) {
    return (
      <a href={props.href} className="feature-link">
        {props.children}
      </a>
    );
  }
  return props.children;
};

const Features = (props) => (
  <section
    className={cx("features", {
      "features--condensed": props.theme === "condensed",
    })}
  >
    <SectionHeading tag="h2">{props.title}</SectionHeading>
    <div className="container-guttered">
      <div className="features-row">
        {props.items.map((item, idx) => {
          const backgroundImage = prismicImage(
            props.media.fabletDown ? item.image.mobile : item.image
          );
          return (
            <FeatureLink key={idx} href={item.href}>
              <div
                className="feature"
                style={{
                  backgroundColor: item.backgroundColor,
                  backgroundImage: `url("${backgroundImage}")`,
                }}
              >
                {props.theme === "condensed" && (
                  <div
                    className="feature-background-overlay"
                    style={{ backgroundColor: item.backgroundColor }}
                  />
                )}
                <RichText
                  color={item.color}
                  fields={item.content}
                  className="feature-content"
                />
                <div className="arrow" />
                {item.cta && item.href && <Button>{item.cta}</Button>}
              </div>
            </FeatureLink>
          );
        })}
      </div>
    </div>
  </section>
);

Features.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.string,
  media: PropTypes.shape({
    fabletDown: PropTypes.bool.isRequired,
  }).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.object.isRequired,
      backgroundColor: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      content: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired,
          spans: PropTypes.array,
        })
      ),
      cta: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      buttonColor: PropTypes.string.isRequired,
    })
  ),
};

export default Features;
